(() => {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire373d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire373d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cZg55", function(module, exports) {


module.exports = self.fetch || (self.fetch = (parcelRequire("fP0pM")).default || (parcelRequire("fP0pM")));

});
parcelRegister("fP0pM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b84bf0ccf614ab66$export$2e2bcd8739ae039);
function $b84bf0ccf614ab66$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});


parcelRegister("3sJij", function(module, exports) {
'use strict';
/* eslint-env browser */ module.exports = typeof self === 'object' ? self.FormData : window.FormData;

});

parcelRegister("9KWm4", function(module, exports) {
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (()=>{
    let warned = false;
    return ()=>{
        if (!warned) {
            warned = true;
            console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
        }
    };
})();
/**
 * Colors.
 */ exports.colors = [
    '#0000CC',
    '#0000FF',
    '#0033CC',
    '#0033FF',
    '#0066CC',
    '#0066FF',
    '#0099CC',
    '#0099FF',
    '#00CC00',
    '#00CC33',
    '#00CC66',
    '#00CC99',
    '#00CCCC',
    '#00CCFF',
    '#3300CC',
    '#3300FF',
    '#3333CC',
    '#3333FF',
    '#3366CC',
    '#3366FF',
    '#3399CC',
    '#3399FF',
    '#33CC00',
    '#33CC33',
    '#33CC66',
    '#33CC99',
    '#33CCCC',
    '#33CCFF',
    '#6600CC',
    '#6600FF',
    '#6633CC',
    '#6633FF',
    '#66CC00',
    '#66CC33',
    '#9900CC',
    '#9900FF',
    '#9933CC',
    '#9933FF',
    '#99CC00',
    '#99CC33',
    '#CC0000',
    '#CC0033',
    '#CC0066',
    '#CC0099',
    '#CC00CC',
    '#CC00FF',
    '#CC3300',
    '#CC3333',
    '#CC3366',
    '#CC3399',
    '#CC33CC',
    '#CC33FF',
    '#CC6600',
    '#CC6633',
    '#CC9900',
    '#CC9933',
    '#CCCC00',
    '#CCCC33',
    '#FF0000',
    '#FF0033',
    '#FF0066',
    '#FF0099',
    '#FF00CC',
    '#FF00FF',
    '#FF3300',
    '#FF3333',
    '#FF3366',
    '#FF3399',
    '#FF33CC',
    '#FF33FF',
    '#FF6600',
    '#FF6633',
    '#FF9900',
    '#FF9933',
    '#FFCC00',
    '#FFCC33'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    const c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, (match)=>{
        if (match === '%%') return;
        index++;
        if (match === '%c') // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ exports.log = console.debug || console.log || (()=>{});
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (namespaces) exports.storage.setItem('debug', namespaces);
        else exports.storage.removeItem('debug');
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    let r;
    try {
        r = exports.storage.getItem('debug');
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    r;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}

module.exports = (parcelRequire("8s8WA"))(exports);
const { formatters } = module.exports;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return '[UnexpectedJSONParseError]: ' + error.message;
    }
};

});
parcelRegister("8s8WA", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ 
function $6277e05a697cddc9$var$setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = (parcelRequire("4N8Pa"));
    createDebug.destroy = destroy;
    Object.keys(env).forEach((key)=>{
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        let hash = 0;
        for(let i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
            // Disabled?
            if (!debug.enabled) return;
            const self = debug;
            // Set `diff` timestamp
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== 'string') // Anything else let's inspect with %O
            args.unshift('%O');
            // Apply any `formatters` transformations
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format)=>{
                // If we encounter an escaped % then don't increase the array index
                if (match === '%%') return '%';
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === 'function') {
                    const val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            const logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, 'enabled', {
            enumerable: true,
            configurable: false,
            get: ()=>{
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: (v)=>{
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === 'function') createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        let i;
        const split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
        const len = split.length;
        for(i = 0; i < len; i++){
            if (!split[i]) continue;
            namespaces = split[i].replace(/\*/g, '.*?');
            if (namespaces[0] === '-') createDebug.skips.push(new RegExp('^' + namespaces.slice(1) + '$'));
            else createDebug.names.push(new RegExp('^' + namespaces + '$'));
        }
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        const namespaces = [
            ...createDebug.names.map(toNamespace),
            ...createDebug.skips.map(toNamespace).map((namespace)=>'-' + namespace)
        ].join(',');
        createDebug.enable('');
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        if (name[name.length - 1] === '*') return true;
        let i;
        let len;
        for(i = 0, len = createDebug.skips.length; i < len; i++){
            if (createDebug.skips[i].test(name)) return false;
        }
        for(i = 0, len = createDebug.names.length; i < len; i++){
            if (createDebug.names[i].test(name)) return true;
        }
        return false;
    }
    /**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/ function toNamespace(regexp) {
        return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, '*');
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = $6277e05a697cddc9$var$setup;

});
parcelRegister("4N8Pa", function(module, exports) {
/**
 * Helpers.
 */ var $37d295599aefcb03$var$s = 1000;
var $37d295599aefcb03$var$m = $37d295599aefcb03$var$s * 60;
var $37d295599aefcb03$var$h = $37d295599aefcb03$var$m * 60;
var $37d295599aefcb03$var$d = $37d295599aefcb03$var$h * 24;
var $37d295599aefcb03$var$w = $37d295599aefcb03$var$d * 7;
var $37d295599aefcb03$var$y = $37d295599aefcb03$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $37d295599aefcb03$var$parse(val);
    else if (type === 'number' && isFinite(val)) return options.long ? $37d295599aefcb03$var$fmtLong(val) : $37d295599aefcb03$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $37d295599aefcb03$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $37d295599aefcb03$var$y;
        case 'weeks':
        case 'week':
        case 'w':
            return n * $37d295599aefcb03$var$w;
        case 'days':
        case 'day':
        case 'd':
            return n * $37d295599aefcb03$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $37d295599aefcb03$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $37d295599aefcb03$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $37d295599aefcb03$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $37d295599aefcb03$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $37d295599aefcb03$var$d) return Math.round(ms / $37d295599aefcb03$var$d) + 'd';
    if (msAbs >= $37d295599aefcb03$var$h) return Math.round(ms / $37d295599aefcb03$var$h) + 'h';
    if (msAbs >= $37d295599aefcb03$var$m) return Math.round(ms / $37d295599aefcb03$var$m) + 'm';
    if (msAbs >= $37d295599aefcb03$var$s) return Math.round(ms / $37d295599aefcb03$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $37d295599aefcb03$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $37d295599aefcb03$var$d) return $37d295599aefcb03$var$plural(ms, msAbs, $37d295599aefcb03$var$d, 'day');
    if (msAbs >= $37d295599aefcb03$var$h) return $37d295599aefcb03$var$plural(ms, msAbs, $37d295599aefcb03$var$h, 'hour');
    if (msAbs >= $37d295599aefcb03$var$m) return $37d295599aefcb03$var$plural(ms, msAbs, $37d295599aefcb03$var$m, 'minute');
    if (msAbs >= $37d295599aefcb03$var$s) return $37d295599aefcb03$var$plural(ms, msAbs, $37d295599aefcb03$var$s, 'second');
    return ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $37d295599aefcb03$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

});



parcelRegister("8Xtnd", function(module, exports) {
"use strict";
/* tslint:disable */ /* eslint-disable */ /**
 * Adzerk Decision API
 * Adzerk Decision API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var $685a9e5dc4496ad9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $685a9e5dc4496ad9$var$__assign = module.exports && module.exports.__assign || function() {
    $685a9e5dc4496ad9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $685a9e5dc4496ad9$var$__assign.apply(this, arguments);
};
var $685a9e5dc4496ad9$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $685a9e5dc4496ad9$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextApiResponse = module.exports.BlobApiResponse = module.exports.VoidApiResponse = module.exports.JSONApiResponse = module.exports.canConsumeForm = module.exports.mapValues = module.exports.querystring = module.exports.exists = module.exports.Configuration = module.exports.COLLECTION_FORMATS = module.exports.RequiredError = module.exports.BaseAPI = module.exports.BASE_PATH = void 0;
module.exports.BASE_PATH = "https://e-23.adzerk.net".replace(/\/+$/, "");
var $685a9e5dc4496ad9$var$isBlob = function(value) {
    return typeof Blob !== 'undefined' && value instanceof Blob;
};
/**
 * This is the base class for all generated API classes.
 */ var $685a9e5dc4496ad9$var$BaseAPI = /** @class */ function() {
    function BaseAPI(configuration) {
        if (configuration === void 0) configuration = new $685a9e5dc4496ad9$var$Configuration();
        var _this = this;
        this.configuration = configuration;
        this.fetchApi = function(url, init) {
            return $685a9e5dc4496ad9$var$__awaiter(_this, void 0, void 0, function() {
                var fetchParams, _i, _a, middleware, response, _b, _c, middleware;
                return $685a9e5dc4496ad9$var$__generator(this, function(_d) {
                    switch(_d.label){
                        case 0:
                            fetchParams = {
                                url: url,
                                init: init
                            };
                            _i = 0, _a = this.middleware;
                            _d.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            middleware = _a[_i];
                            if (!middleware.pre) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                middleware.pre($685a9e5dc4496ad9$var$__assign({
                                    fetch: this.fetchApi
                                }, fetchParams))
                            ];
                        case 2:
                            fetchParams = _d.sent() || fetchParams;
                            _d.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                4 /*yield*/ ,
                                this.configuration.fetchApi(fetchParams.url, fetchParams.init)
                            ];
                        case 5:
                            response = _d.sent();
                            _b = 0, _c = this.middleware;
                            _d.label = 6;
                        case 6:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                9
                            ];
                            middleware = _c[_b];
                            if (!middleware.post) return [
                                3 /*break*/ ,
                                8
                            ];
                            return [
                                4 /*yield*/ ,
                                middleware.post({
                                    fetch: this.fetchApi,
                                    url: url,
                                    init: init,
                                    response: response.clone()
                                })
                            ];
                        case 7:
                            response = _d.sent() || response;
                            _d.label = 8;
                        case 8:
                            _b++;
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 9:
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
        this.middleware = configuration.middleware;
    }
    BaseAPI.prototype.withMiddleware = function() {
        var _a;
        var middlewares = [];
        for(var _i = 0; _i < arguments.length; _i++)middlewares[_i] = arguments[_i];
        var next = this.clone();
        next.middleware = (_a = next.middleware).concat.apply(_a, middlewares);
        return next;
    };
    BaseAPI.prototype.withPreMiddleware = function() {
        var preMiddlewares = [];
        for(var _i = 0; _i < arguments.length; _i++)preMiddlewares[_i] = arguments[_i];
        var middlewares = preMiddlewares.map(function(pre) {
            return {
                pre: pre
            };
        });
        return this.withMiddleware.apply(this, middlewares);
    };
    BaseAPI.prototype.withPostMiddleware = function() {
        var postMiddlewares = [];
        for(var _i = 0; _i < arguments.length; _i++)postMiddlewares[_i] = arguments[_i];
        var middlewares = postMiddlewares.map(function(post) {
            return {
                post: post
            };
        });
        return this.withMiddleware.apply(this, middlewares);
    };
    BaseAPI.prototype.request = function(context) {
        return $685a9e5dc4496ad9$var$__awaiter(this, void 0, void 0, function() {
            var _a, url, init, response;
            return $685a9e5dc4496ad9$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this.createFetchParams(context), url = _a.url, init = _a.init;
                        return [
                            4 /*yield*/ ,
                            this.fetchApi(url, init)
                        ];
                    case 1:
                        response = _b.sent();
                        if (response.status >= 200 && response.status < 300) return [
                            2 /*return*/ ,
                            response
                        ];
                        throw response;
                }
            });
        });
    };
    BaseAPI.prototype.createFetchParams = function(context) {
        var url = this.configuration.basePath + context.path;
        if (context.query !== undefined && Object.keys(context.query).length !== 0) // only add the querystring to the URL if there are query parameters.
        // this is done to avoid urls ending with a "?" character which buggy webservers
        // do not handle correctly sometimes.
        url += '?' + this.configuration.queryParamsStringify(context.query);
        var body = typeof FormData !== "undefined" && context.body instanceof FormData || context.body instanceof URLSearchParams || $685a9e5dc4496ad9$var$isBlob(context.body) ? context.body : JSON.stringify(context.body);
        var headers = Object.assign({}, this.configuration.headers, context.headers);
        var init = {
            method: context.method,
            headers: headers,
            body: body,
            credentials: this.configuration.credentials
        };
        return {
            url: url,
            init: init
        };
    };
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */ BaseAPI.prototype.clone = function() {
        var constructor = this.constructor;
        var next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    };
    return BaseAPI;
}();
module.exports.BaseAPI = $685a9e5dc4496ad9$var$BaseAPI;
var $685a9e5dc4496ad9$var$RequiredError = /** @class */ function(_super) {
    $685a9e5dc4496ad9$var$__extends(RequiredError, _super);
    function RequiredError(field, msg) {
        var _this = _super.call(this, msg) || this;
        _this.field = field;
        _this.name = "RequiredError";
        return _this;
    }
    return RequiredError;
}(Error);
module.exports.RequiredError = $685a9e5dc4496ad9$var$RequiredError;
module.exports.COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|"
};
var $685a9e5dc4496ad9$var$Configuration = /** @class */ function() {
    function Configuration(configuration) {
        if (configuration === void 0) configuration = {};
        this.configuration = configuration;
    }
    Object.defineProperty(Configuration.prototype, "basePath", {
        get: function() {
            return this.configuration.basePath != null ? this.configuration.basePath : module.exports.BASE_PATH;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "fetchApi", {
        get: function() {
            return this.configuration.fetchApi || window.fetch.bind(window);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "middleware", {
        get: function() {
            return this.configuration.middleware || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "queryParamsStringify", {
        get: function() {
            return this.configuration.queryParamsStringify || $685a9e5dc4496ad9$var$querystring;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "username", {
        get: function() {
            return this.configuration.username;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "password", {
        get: function() {
            return this.configuration.password;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "apiKey", {
        get: function() {
            var apiKey = this.configuration.apiKey;
            if (apiKey) return typeof apiKey === 'function' ? apiKey : function() {
                return apiKey;
            };
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "accessToken", {
        get: function() {
            var accessToken = this.configuration.accessToken;
            if (accessToken) return typeof accessToken === 'function' ? accessToken : function() {
                return accessToken;
            };
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "headers", {
        get: function() {
            return this.configuration.headers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "credentials", {
        get: function() {
            return this.configuration.credentials;
        },
        enumerable: false,
        configurable: true
    });
    return Configuration;
}();
module.exports.Configuration = $685a9e5dc4496ad9$var$Configuration;
function $685a9e5dc4496ad9$var$exists(json, key) {
    var value = json[key];
    return value !== null && value !== undefined;
}
module.exports.exists = $685a9e5dc4496ad9$var$exists;
function $685a9e5dc4496ad9$var$querystring(params, prefix) {
    if (prefix === void 0) prefix = '';
    return Object.keys(params).map(function(key) {
        var fullKey = prefix + (prefix.length ? "[".concat(key, "]") : key);
        var value = params[key];
        if (value instanceof Array) {
            var multiValue = value.map(function(singleValue) {
                return encodeURIComponent(String(singleValue));
            }).join("&".concat(encodeURIComponent(fullKey), "="));
            return "".concat(encodeURIComponent(fullKey), "=").concat(multiValue);
        }
        if (value instanceof Date) return "".concat(encodeURIComponent(fullKey), "=").concat(encodeURIComponent(value.toISOString()));
        if (value instanceof Object) return $685a9e5dc4496ad9$var$querystring(value, fullKey);
        return "".concat(encodeURIComponent(fullKey), "=").concat(encodeURIComponent(String(value)));
    }).filter(function(part) {
        return part.length > 0;
    }).join('&');
}
module.exports.querystring = $685a9e5dc4496ad9$var$querystring;
function $685a9e5dc4496ad9$var$mapValues(data, fn) {
    return Object.keys(data).reduce(function(acc, key) {
        var _a;
        return $685a9e5dc4496ad9$var$__assign($685a9e5dc4496ad9$var$__assign({}, acc), (_a = {}, _a[key] = fn(data[key]), _a));
    }, {});
}
module.exports.mapValues = $685a9e5dc4496ad9$var$mapValues;
function $685a9e5dc4496ad9$var$canConsumeForm(consumes) {
    for(var _i = 0, consumes_1 = consumes; _i < consumes_1.length; _i++){
        var consume = consumes_1[_i];
        if ('multipart/form-data' === consume.contentType) return true;
    }
    return false;
}
module.exports.canConsumeForm = $685a9e5dc4496ad9$var$canConsumeForm;
var $685a9e5dc4496ad9$var$JSONApiResponse = /** @class */ function() {
    function JSONApiResponse(raw, transformer) {
        if (transformer === void 0) transformer = function(jsonValue) {
            return jsonValue;
        };
        this.raw = raw;
        this.transformer = transformer;
    }
    JSONApiResponse.prototype.value = function() {
        return $685a9e5dc4496ad9$var$__awaiter(this, void 0, void 0, function() {
            var _a;
            return $685a9e5dc4496ad9$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this.transformer;
                        return [
                            4 /*yield*/ ,
                            this.raw.json()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.apply(this, [
                                _b.sent()
                            ])
                        ];
                }
            });
        });
    };
    return JSONApiResponse;
}();
module.exports.JSONApiResponse = $685a9e5dc4496ad9$var$JSONApiResponse;
var $685a9e5dc4496ad9$var$VoidApiResponse = /** @class */ function() {
    function VoidApiResponse(raw) {
        this.raw = raw;
    }
    VoidApiResponse.prototype.value = function() {
        return $685a9e5dc4496ad9$var$__awaiter(this, void 0, void 0, function() {
            return $685a9e5dc4496ad9$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    undefined
                ];
            });
        });
    };
    return VoidApiResponse;
}();
module.exports.VoidApiResponse = $685a9e5dc4496ad9$var$VoidApiResponse;
var $685a9e5dc4496ad9$var$BlobApiResponse = /** @class */ function() {
    function BlobApiResponse(raw) {
        this.raw = raw;
    }
    BlobApiResponse.prototype.value = function() {
        return $685a9e5dc4496ad9$var$__awaiter(this, void 0, void 0, function() {
            return $685a9e5dc4496ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.raw.blob()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    return BlobApiResponse;
}();
module.exports.BlobApiResponse = $685a9e5dc4496ad9$var$BlobApiResponse;
var $685a9e5dc4496ad9$var$TextApiResponse = /** @class */ function() {
    function TextApiResponse(raw) {
        this.raw = raw;
    }
    TextApiResponse.prototype.value = function() {
        return $685a9e5dc4496ad9$var$__awaiter(this, void 0, void 0, function() {
            return $685a9e5dc4496ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.raw.text()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    return TextApiResponse;
}();
module.exports.TextApiResponse = $685a9e5dc4496ad9$var$TextApiResponse;

});

parcelRegister("9g4bz", function(module, exports) {
"use strict";
var $6bd8dadd547412eb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6bd8dadd547412eb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6bd8dadd547412eb$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6bd8dadd547412eb$var$__exportStar((parcelRequire("aQDAi")), module.exports);

$6bd8dadd547412eb$var$__exportStar((parcelRequire("2gkyr")), module.exports);

});
parcelRegister("aQDAi", function(module, exports) {
"use strict";
/* tslint:disable */ /* eslint-disable */ /**
 * Adzerk Decision API
 * Adzerk Decision API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var $7e5d775e89c7e66f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7e5d775e89c7e66f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7e5d775e89c7e66f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecisionApi = void 0;

var $8Xtnd = parcelRequire("8Xtnd");

var $2LYTS = parcelRequire("2LYTS");
/**
 *
 */ var $7e5d775e89c7e66f$var$DecisionApi = /** @class */ function(_super) {
    $7e5d775e89c7e66f$var$__extends(DecisionApi, _super);
    function DecisionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Request Decision(s)
     */ DecisionApi.prototype.getDecisionsRaw = function(requestParameters) {
        return $7e5d775e89c7e66f$var$__awaiter(this, void 0, void 0, function() {
            var queryParameters, headerParameters, response;
            return $7e5d775e89c7e66f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [
                            4 /*yield*/ ,
                            this.request({
                                path: "/api/v2",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, $2LYTS.DecisionRequestToJSON)(requestParameters.decisionRequest)
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            new $8Xtnd.JSONApiResponse(response, function(jsonValue) {
                                return (0, $2LYTS.DecisionResponseFromJSON)(jsonValue);
                            })
                        ];
                }
            });
        });
    };
    /**
     * Request Decision(s)
     */ DecisionApi.prototype.getDecisions = function(decisionRequest) {
        return $7e5d775e89c7e66f$var$__awaiter(this, void 0, void 0, function() {
            var response;
            return $7e5d775e89c7e66f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getDecisionsRaw({
                                decisionRequest: decisionRequest
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            response.value()
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    return DecisionApi;
}($8Xtnd.BaseAPI);
module.exports.DecisionApi = $7e5d775e89c7e66f$var$DecisionApi;

});
parcelRegister("2LYTS", function(module, exports) {
"use strict";
var $204f36176604f47b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $204f36176604f47b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $204f36176604f47b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$204f36176604f47b$var$__exportStar((parcelRequire("fy49N")), module.exports);

$204f36176604f47b$var$__exportStar((parcelRequire("kXsp6")), module.exports);

$204f36176604f47b$var$__exportStar((parcelRequire("a0gem")), module.exports);

$204f36176604f47b$var$__exportStar((parcelRequire("7HEIU")), module.exports);

$204f36176604f47b$var$__exportStar((parcelRequire("7HiuK")), module.exports);

$204f36176604f47b$var$__exportStar((parcelRequire("1PwJs")), module.exports);

$204f36176604f47b$var$__exportStar((parcelRequire("fZaEu")), module.exports);

$204f36176604f47b$var$__exportStar((parcelRequire("iD4JW")), module.exports);

$204f36176604f47b$var$__exportStar((parcelRequire("aRuVz")), module.exports);

$204f36176604f47b$var$__exportStar((parcelRequire("9Ulnb")), module.exports);

$204f36176604f47b$var$__exportStar((parcelRequire("h3K2C")), module.exports);

});
parcelRegister("fy49N", function(module, exports) {
"use strict";
/* tslint:disable */ /* eslint-disable */ /**
 * Adzerk Decision API
 * Adzerk Decision API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsentRequestToJSON = module.exports.ConsentRequestFromJSONTyped = module.exports.ConsentRequestFromJSON = void 0;

var $8Xtnd = parcelRequire("8Xtnd");
function $b51d417a046e6710$var$ConsentRequestFromJSON(json) {
    return $b51d417a046e6710$var$ConsentRequestFromJSONTyped(json, false);
}
module.exports.ConsentRequestFromJSON = $b51d417a046e6710$var$ConsentRequestFromJSON;
function $b51d417a046e6710$var$ConsentRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'userKey': !(0, $8Xtnd.exists)(json, 'userKey') ? undefined : json['userKey'],
        'consent': !(0, $8Xtnd.exists)(json, 'consent') ? undefined : json['consent']
    };
}
module.exports.ConsentRequestFromJSONTyped = $b51d417a046e6710$var$ConsentRequestFromJSONTyped;
function $b51d417a046e6710$var$ConsentRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'userKey': value.userKey,
        'consent': value.consent
    };
}
module.exports.ConsentRequestToJSON = $b51d417a046e6710$var$ConsentRequestToJSON;

});

parcelRegister("kXsp6", function(module, exports) {
"use strict";
/* tslint:disable */ /* eslint-disable */ /**
 * Adzerk Decision API
 * Adzerk Decision API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContentToJSON = module.exports.ContentFromJSONTyped = module.exports.ContentFromJSON = void 0;

var $8Xtnd = parcelRequire("8Xtnd");
function $f41f59c3382f0153$var$ContentFromJSON(json) {
    return $f41f59c3382f0153$var$ContentFromJSONTyped(json, false);
}
module.exports.ContentFromJSON = $f41f59c3382f0153$var$ContentFromJSON;
function $f41f59c3382f0153$var$ContentFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'type': !(0, $8Xtnd.exists)(json, 'type') ? undefined : json['type'],
        'template': !(0, $8Xtnd.exists)(json, 'template') ? undefined : json['template'],
        'customTemplate': !(0, $8Xtnd.exists)(json, 'customTemplate') ? undefined : json['customTemplate'],
        'data': !(0, $8Xtnd.exists)(json, 'data') ? undefined : json['data'],
        'body': !(0, $8Xtnd.exists)(json, 'body') ? undefined : json['body']
    };
}
module.exports.ContentFromJSONTyped = $f41f59c3382f0153$var$ContentFromJSONTyped;
function $f41f59c3382f0153$var$ContentToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'type': value.type,
        'template': value.template,
        'customTemplate': value.customTemplate,
        'data': value.data,
        'body': value.body
    };
}
module.exports.ContentToJSON = $f41f59c3382f0153$var$ContentToJSON;

});

parcelRegister("a0gem", function(module, exports) {
"use strict";
/* tslint:disable */ /* eslint-disable */ /**
 * Adzerk Decision API
 * Adzerk Decision API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecisionToJSON = module.exports.DecisionFromJSONTyped = module.exports.DecisionFromJSON = void 0;

var $8Xtnd = parcelRequire("8Xtnd");

var $2LYTS = parcelRequire("2LYTS");
function $74867e86ef4714fc$var$DecisionFromJSON(json) {
    return $74867e86ef4714fc$var$DecisionFromJSONTyped(json, false);
}
module.exports.DecisionFromJSON = $74867e86ef4714fc$var$DecisionFromJSON;
function $74867e86ef4714fc$var$DecisionFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'adId': !(0, $8Xtnd.exists)(json, 'adId') ? undefined : json['adId'],
        'advertiserId': !(0, $8Xtnd.exists)(json, 'advertiserId') ? undefined : json['advertiserId'],
        'creativeId': !(0, $8Xtnd.exists)(json, 'creativeId') ? undefined : json['creativeId'],
        'flightId': !(0, $8Xtnd.exists)(json, 'flightId') ? undefined : json['flightId'],
        'campaignId': !(0, $8Xtnd.exists)(json, 'campaignId') ? undefined : json['campaignId'],
        'priorityId': !(0, $8Xtnd.exists)(json, 'priorityId') ? undefined : json['priorityId'],
        'clickUrl': !(0, $8Xtnd.exists)(json, 'clickUrl') ? undefined : json['clickUrl'],
        'contents': !(0, $8Xtnd.exists)(json, 'contents') ? undefined : json['contents'].map($2LYTS.ContentFromJSON),
        'impressionUrl': !(0, $8Xtnd.exists)(json, 'impressionUrl') ? undefined : json['impressionUrl'],
        'events': !(0, $8Xtnd.exists)(json, 'events') ? undefined : json['events'].map($2LYTS.EventFromJSON),
        'matchedPoints': !(0, $8Xtnd.exists)(json, 'matchedPoints') ? undefined : json['matchedPoints'].map($2LYTS.MatchedPointFromJSON),
        'pricing': !(0, $8Xtnd.exists)(json, 'pricing') ? undefined : (0, $2LYTS.PricingDataFromJSON)(json['pricing'])
    };
}
module.exports.DecisionFromJSONTyped = $74867e86ef4714fc$var$DecisionFromJSONTyped;
function $74867e86ef4714fc$var$DecisionToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'adId': value.adId,
        'advertiserId': value.advertiserId,
        'creativeId': value.creativeId,
        'flightId': value.flightId,
        'campaignId': value.campaignId,
        'priorityId': value.priorityId,
        'clickUrl': value.clickUrl,
        'contents': value.contents === undefined ? undefined : value.contents.map($2LYTS.ContentToJSON),
        'impressionUrl': value.impressionUrl,
        'events': value.events === undefined ? undefined : value.events.map($2LYTS.EventToJSON),
        'matchedPoints': value.matchedPoints === undefined ? undefined : value.matchedPoints.map($2LYTS.MatchedPointToJSON),
        'pricing': (0, $2LYTS.PricingDataToJSON)(value.pricing)
    };
}
module.exports.DecisionToJSON = $74867e86ef4714fc$var$DecisionToJSON;

});

parcelRegister("7HEIU", function(module, exports) {
"use strict";
/* tslint:disable */ /* eslint-disable */ /**
 * Adzerk Decision API
 * Adzerk Decision API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecisionRequestToJSON = module.exports.DecisionRequestFromJSONTyped = module.exports.DecisionRequestFromJSON = void 0;

var $8Xtnd = parcelRequire("8Xtnd");

var $2LYTS = parcelRequire("2LYTS");
function $59bc23609e508f80$var$DecisionRequestFromJSON(json) {
    return $59bc23609e508f80$var$DecisionRequestFromJSONTyped(json, false);
}
module.exports.DecisionRequestFromJSON = $59bc23609e508f80$var$DecisionRequestFromJSON;
function $59bc23609e508f80$var$DecisionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'placements': json['placements'].map($2LYTS.PlacementFromJSON),
        'user': !(0, $8Xtnd.exists)(json, 'user') ? undefined : (0, $2LYTS.UserFromJSON)(json['user']),
        'keywords': !(0, $8Xtnd.exists)(json, 'keywords') ? undefined : json['keywords'],
        'url': !(0, $8Xtnd.exists)(json, 'url') ? undefined : json['url'],
        'referrer': !(0, $8Xtnd.exists)(json, 'referrer') ? undefined : json['referrer'],
        'ip': !(0, $8Xtnd.exists)(json, 'ip') ? undefined : json['ip'],
        'blockedCreatives': !(0, $8Xtnd.exists)(json, 'blockedCreatives') ? undefined : json['blockedCreatives'],
        'isMobile': !(0, $8Xtnd.exists)(json, 'isMobile') ? undefined : json['isMobile'],
        'includePricingData': !(0, $8Xtnd.exists)(json, 'includePricingData') ? undefined : json['includePricingData'],
        'notrack': !(0, $8Xtnd.exists)(json, 'notrack') ? undefined : json['notrack'],
        'enableBotFiltering': !(0, $8Xtnd.exists)(json, 'enableBotFiltering') ? undefined : json['enableBotFiltering'],
        'enableUserDBIP': !(0, $8Xtnd.exists)(json, 'enableUserDBIP') ? undefined : json['enableUserDBIP'],
        'consent': !(0, $8Xtnd.exists)(json, 'consent') ? undefined : json['consent'],
        'deviceID': !(0, $8Xtnd.exists)(json, 'deviceID') ? undefined : json['deviceID'],
        'parallel': !(0, $8Xtnd.exists)(json, 'parallel') ? undefined : json['parallel'],
        'intendedLatitude': !(0, $8Xtnd.exists)(json, 'intendedLatitude') ? undefined : json['intendedLatitude'],
        'intendedLongitude': !(0, $8Xtnd.exists)(json, 'intendedLongitude') ? undefined : json['intendedLongitude'],
        'radius': !(0, $8Xtnd.exists)(json, 'radius') ? undefined : json['radius'],
        'includeMatchedPoints': !(0, $8Xtnd.exists)(json, 'includeMatchedPoints') ? undefined : json['includeMatchedPoints']
    };
}
module.exports.DecisionRequestFromJSONTyped = $59bc23609e508f80$var$DecisionRequestFromJSONTyped;
function $59bc23609e508f80$var$DecisionRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'placements': value.placements.map($2LYTS.PlacementToJSON),
        'user': (0, $2LYTS.UserToJSON)(value.user),
        'keywords': value.keywords,
        'url': value.url,
        'referrer': value.referrer,
        'ip': value.ip,
        'blockedCreatives': value.blockedCreatives,
        'isMobile': value.isMobile,
        'includePricingData': value.includePricingData,
        'notrack': value.notrack,
        'enableBotFiltering': value.enableBotFiltering,
        'enableUserDBIP': value.enableUserDBIP,
        'consent': value.consent,
        'deviceID': value.deviceID,
        'parallel': value.parallel,
        'intendedLatitude': value.intendedLatitude,
        'intendedLongitude': value.intendedLongitude,
        'radius': value.radius,
        'includeMatchedPoints': value.includeMatchedPoints
    };
}
module.exports.DecisionRequestToJSON = $59bc23609e508f80$var$DecisionRequestToJSON;

});

parcelRegister("7HiuK", function(module, exports) {
"use strict";
/* tslint:disable */ /* eslint-disable */ /**
 * Adzerk Decision API
 * Adzerk Decision API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecisionResponseToJSON = module.exports.DecisionResponseFromJSONTyped = module.exports.DecisionResponseFromJSON = void 0;

var $8Xtnd = parcelRequire("8Xtnd");

var $2LYTS = parcelRequire("2LYTS");
function $59aae54702158249$var$DecisionResponseFromJSON(json) {
    return $59aae54702158249$var$DecisionResponseFromJSONTyped(json, false);
}
module.exports.DecisionResponseFromJSON = $59aae54702158249$var$DecisionResponseFromJSON;
function $59aae54702158249$var$DecisionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'user': !(0, $8Xtnd.exists)(json, 'user') ? undefined : (0, $2LYTS.UserFromJSON)(json['user']),
        'decisions': !(0, $8Xtnd.exists)(json, 'decisions') ? undefined : json['decisions'],
        'explain': !(0, $8Xtnd.exists)(json, 'explain') ? undefined : json['explain']
    };
}
module.exports.DecisionResponseFromJSONTyped = $59aae54702158249$var$DecisionResponseFromJSONTyped;
function $59aae54702158249$var$DecisionResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'user': (0, $2LYTS.UserToJSON)(value.user),
        'decisions': value.decisions,
        'explain': value.explain
    };
}
module.exports.DecisionResponseToJSON = $59aae54702158249$var$DecisionResponseToJSON;

});

parcelRegister("1PwJs", function(module, exports) {
"use strict";
/* tslint:disable */ /* eslint-disable */ /**
 * Adzerk Decision API
 * Adzerk Decision API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventToJSON = module.exports.EventFromJSONTyped = module.exports.EventFromJSON = void 0;

var $8Xtnd = parcelRequire("8Xtnd");
function $1553f1cfc9a3babf$var$EventFromJSON(json) {
    return $1553f1cfc9a3babf$var$EventFromJSONTyped(json, false);
}
module.exports.EventFromJSON = $1553f1cfc9a3babf$var$EventFromJSON;
function $1553f1cfc9a3babf$var$EventFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'id': !(0, $8Xtnd.exists)(json, 'id') ? undefined : json['id'],
        'url': !(0, $8Xtnd.exists)(json, 'url') ? undefined : json['url']
    };
}
module.exports.EventFromJSONTyped = $1553f1cfc9a3babf$var$EventFromJSONTyped;
function $1553f1cfc9a3babf$var$EventToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'id': value.id,
        'url': value.url
    };
}
module.exports.EventToJSON = $1553f1cfc9a3babf$var$EventToJSON;

});

parcelRegister("fZaEu", function(module, exports) {
"use strict";
/* tslint:disable */ /* eslint-disable */ /**
 * Adzerk Decision API
 * Adzerk Decision API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MatchedPointToJSON = module.exports.MatchedPointFromJSONTyped = module.exports.MatchedPointFromJSON = void 0;

var $8Xtnd = parcelRequire("8Xtnd");
function $ba34d0d00b2f2c5d$var$MatchedPointFromJSON(json) {
    return $ba34d0d00b2f2c5d$var$MatchedPointFromJSONTyped(json, false);
}
module.exports.MatchedPointFromJSON = $ba34d0d00b2f2c5d$var$MatchedPointFromJSON;
function $ba34d0d00b2f2c5d$var$MatchedPointFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'lat': !(0, $8Xtnd.exists)(json, 'lat') ? undefined : json['lat'],
        'lon': !(0, $8Xtnd.exists)(json, 'lon') ? undefined : json['lon']
    };
}
module.exports.MatchedPointFromJSONTyped = $ba34d0d00b2f2c5d$var$MatchedPointFromJSONTyped;
function $ba34d0d00b2f2c5d$var$MatchedPointToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'lat': value.lat,
        'lon': value.lon
    };
}
module.exports.MatchedPointToJSON = $ba34d0d00b2f2c5d$var$MatchedPointToJSON;

});

parcelRegister("iD4JW", function(module, exports) {
"use strict";
/* tslint:disable */ /* eslint-disable */ /**
 * Adzerk Decision API
 * Adzerk Decision API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlacementToJSON = module.exports.PlacementFromJSONTyped = module.exports.PlacementFromJSON = void 0;

var $8Xtnd = parcelRequire("8Xtnd");

var $2LYTS = parcelRequire("2LYTS");
function $d8ff8bccf180df8f$var$PlacementFromJSON(json) {
    return $d8ff8bccf180df8f$var$PlacementFromJSONTyped(json, false);
}
module.exports.PlacementFromJSON = $d8ff8bccf180df8f$var$PlacementFromJSON;
function $d8ff8bccf180df8f$var$PlacementFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'divName': !(0, $8Xtnd.exists)(json, 'divName') ? undefined : json['divName'],
        'networkId': !(0, $8Xtnd.exists)(json, 'networkId') ? undefined : json['networkId'],
        'siteId': !(0, $8Xtnd.exists)(json, 'siteId') ? undefined : json['siteId'],
        'adTypes': !(0, $8Xtnd.exists)(json, 'adTypes') ? undefined : json['adTypes'],
        'zoneIds': !(0, $8Xtnd.exists)(json, 'zoneIds') ? undefined : json['zoneIds'],
        'campaignId': !(0, $8Xtnd.exists)(json, 'campaignId') ? undefined : json['campaignId'],
        'flightId': !(0, $8Xtnd.exists)(json, 'flightId') ? undefined : json['flightId'],
        'adId': !(0, $8Xtnd.exists)(json, 'adId') ? undefined : json['adId'],
        'clickUrl': !(0, $8Xtnd.exists)(json, 'clickUrl') ? undefined : json['clickUrl'],
        'properties': !(0, $8Xtnd.exists)(json, 'properties') ? undefined : json['properties'],
        'eventIds': !(0, $8Xtnd.exists)(json, 'eventIds') ? undefined : json['eventIds'],
        'overrides': !(0, $8Xtnd.exists)(json, 'overrides') ? undefined : json['overrides'],
        'contentKeys': !(0, $8Xtnd.exists)(json, 'contentKeys') ? undefined : json['contentKeys'],
        'count': !(0, $8Xtnd.exists)(json, 'count') ? undefined : json['count'],
        'proportionality': !(0, $8Xtnd.exists)(json, 'proportionality') ? undefined : json['proportionality'],
        'ecpmPartition': !(0, $8Xtnd.exists)(json, 'ecpmPartition') ? undefined : json['ecpmPartition'],
        'ecpmPartitions': !(0, $8Xtnd.exists)(json, 'ecpmPartitions') ? undefined : json['ecpmPartitions'],
        'eventMultiplier': !(0, $8Xtnd.exists)(json, 'eventMultiplier') ? undefined : json['eventMultiplier'],
        'skipSelection': !(0, $8Xtnd.exists)(json, 'skipSelection') ? undefined : json['skipSelection'],
        'adQuery': !(0, $8Xtnd.exists)(json, 'adQuery') ? undefined : json['adQuery'],
        'floorPrice': !(0, $8Xtnd.exists)(json, 'floorPrice') ? undefined : json['floorPrice'],
        'floorCpc': !(0, $8Xtnd.exists)(json, 'floorCpc') ? undefined : json['floorCpc'],
        'skipFilters': !(0, $8Xtnd.exists)(json, 'skipFilters') ? undefined : (0, $2LYTS.SkipFiltersFromJSON)(json['skipFilters'])
    };
}
module.exports.PlacementFromJSONTyped = $d8ff8bccf180df8f$var$PlacementFromJSONTyped;
function $d8ff8bccf180df8f$var$PlacementToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'divName': value.divName,
        'networkId': value.networkId,
        'siteId': value.siteId,
        'adTypes': value.adTypes,
        'zoneIds': value.zoneIds,
        'campaignId': value.campaignId,
        'flightId': value.flightId,
        'adId': value.adId,
        'clickUrl': value.clickUrl,
        'properties': value.properties,
        'eventIds': value.eventIds,
        'overrides': value.overrides,
        'contentKeys': value.contentKeys,
        'count': value.count,
        'proportionality': value.proportionality,
        'ecpmPartition': value.ecpmPartition,
        'ecpmPartitions': value.ecpmPartitions,
        'eventMultiplier': value.eventMultiplier,
        'skipSelection': value.skipSelection,
        'adQuery': value.adQuery,
        'floorPrice': value.floorPrice,
        'floorCpc': value.floorCpc,
        'skipFilters': (0, $2LYTS.SkipFiltersToJSON)(value.skipFilters)
    };
}
module.exports.PlacementToJSON = $d8ff8bccf180df8f$var$PlacementToJSON;

});

parcelRegister("aRuVz", function(module, exports) {
"use strict";
/* tslint:disable */ /* eslint-disable */ /**
 * Adzerk Decision API
 * Adzerk Decision API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PricingDataToJSON = module.exports.PricingDataFromJSONTyped = module.exports.PricingDataFromJSON = void 0;

var $8Xtnd = parcelRequire("8Xtnd");
function $7e86d82ab635dcf5$var$PricingDataFromJSON(json) {
    return $7e86d82ab635dcf5$var$PricingDataFromJSONTyped(json, false);
}
module.exports.PricingDataFromJSON = $7e86d82ab635dcf5$var$PricingDataFromJSON;
function $7e86d82ab635dcf5$var$PricingDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'price': !(0, $8Xtnd.exists)(json, 'price') ? undefined : json['price'],
        'clearPrice': !(0, $8Xtnd.exists)(json, 'clearPrice') ? undefined : json['clearPrice'],
        'revenue': !(0, $8Xtnd.exists)(json, 'revenue') ? undefined : json['revenue'],
        'rateType': !(0, $8Xtnd.exists)(json, 'rateType') ? undefined : json['rateType'],
        'eCPM': !(0, $8Xtnd.exists)(json, 'eCPM') ? undefined : json['eCPM']
    };
}
module.exports.PricingDataFromJSONTyped = $7e86d82ab635dcf5$var$PricingDataFromJSONTyped;
function $7e86d82ab635dcf5$var$PricingDataToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'price': value.price,
        'clearPrice': value.clearPrice,
        'revenue': value.revenue,
        'rateType': value.rateType,
        'eCPM': value.eCPM
    };
}
module.exports.PricingDataToJSON = $7e86d82ab635dcf5$var$PricingDataToJSON;

});

parcelRegister("9Ulnb", function(module, exports) {
"use strict";
/* tslint:disable */ /* eslint-disable */ /**
 * Adzerk Decision API
 * Adzerk Decision API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SkipFiltersToJSON = module.exports.SkipFiltersFromJSONTyped = module.exports.SkipFiltersFromJSON = void 0;

var $8Xtnd = parcelRequire("8Xtnd");
function $7369ec40dc555966$var$SkipFiltersFromJSON(json) {
    return $7369ec40dc555966$var$SkipFiltersFromJSONTyped(json, false);
}
module.exports.SkipFiltersFromJSON = $7369ec40dc555966$var$SkipFiltersFromJSON;
function $7369ec40dc555966$var$SkipFiltersFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'distance': !(0, $8Xtnd.exists)(json, 'distance') ? undefined : json['distance'],
        'facet': !(0, $8Xtnd.exists)(json, 'facet') ? undefined : json['facet'],
        'geodistance': !(0, $8Xtnd.exists)(json, 'geodistance') ? undefined : json['geodistance'],
        'geolocation': !(0, $8Xtnd.exists)(json, 'geolocation') ? undefined : json['geolocation'],
        'keyword': !(0, $8Xtnd.exists)(json, 'keyword') ? undefined : json['keyword'],
        'location': !(0, $8Xtnd.exists)(json, 'location') ? undefined : json['location'],
        'placementLimit': !(0, $8Xtnd.exists)(json, 'placementLimit') ? undefined : json['placementLimit'],
        'siteZone': !(0, $8Xtnd.exists)(json, 'siteZone') ? undefined : json['siteZone']
    };
}
module.exports.SkipFiltersFromJSONTyped = $7369ec40dc555966$var$SkipFiltersFromJSONTyped;
function $7369ec40dc555966$var$SkipFiltersToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'distance': value.distance,
        'facet': value.facet,
        'geodistance': value.geodistance,
        'geolocation': value.geolocation,
        'keyword': value.keyword,
        'location': value.location,
        'placementLimit': value.placementLimit,
        'siteZone': value.siteZone
    };
}
module.exports.SkipFiltersToJSON = $7369ec40dc555966$var$SkipFiltersToJSON;

});

parcelRegister("h3K2C", function(module, exports) {
"use strict";
/* tslint:disable */ /* eslint-disable */ /**
 * Adzerk Decision API
 * Adzerk Decision API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UserToJSON = module.exports.UserFromJSONTyped = module.exports.UserFromJSON = void 0;

var $8Xtnd = parcelRequire("8Xtnd");
function $c6b66e502f31e63d$var$UserFromJSON(json) {
    return $c6b66e502f31e63d$var$UserFromJSONTyped(json, false);
}
module.exports.UserFromJSON = $c6b66e502f31e63d$var$UserFromJSON;
function $c6b66e502f31e63d$var$UserFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'key': !(0, $8Xtnd.exists)(json, 'key') ? undefined : json['key']
    };
}
module.exports.UserFromJSONTyped = $c6b66e502f31e63d$var$UserFromJSONTyped;
function $c6b66e502f31e63d$var$UserToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'key': value.key
    };
}
module.exports.UserToJSON = $c6b66e502f31e63d$var$UserToJSON;

});



parcelRegister("2gkyr", function(module, exports) {
"use strict";
/* tslint:disable */ /* eslint-disable */ /**
 * Adzerk Decision API
 * Adzerk Decision API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var $1a5d0513d6de6ad9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1a5d0513d6de6ad9$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1a5d0513d6de6ad9$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UserdbApi = void 0;

var $8Xtnd = parcelRequire("8Xtnd");

var $2LYTS = parcelRequire("2LYTS");
/**
 *
 */ var $1a5d0513d6de6ad9$var$UserdbApi = /** @class */ function(_super) {
    $1a5d0513d6de6ad9$var$__extends(UserdbApi, _super);
    function UserdbApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Add Custom Properties to a User
     */ UserdbApi.prototype.addCustomPropertiesRaw = function(requestParameters) {
        return $1a5d0513d6de6ad9$var$__awaiter(this, void 0, void 0, function() {
            var queryParameters, headerParameters, response;
            return $1a5d0513d6de6ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (requestParameters.networkId === null || requestParameters.networkId === undefined) throw new $8Xtnd.RequiredError('networkId', 'Required parameter requestParameters.networkId was null or undefined when calling addCustomProperties.');
                        if (requestParameters.userKey === null || requestParameters.userKey === undefined) throw new $8Xtnd.RequiredError('userKey', 'Required parameter requestParameters.userKey was null or undefined when calling addCustomProperties.');
                        queryParameters = {};
                        if (requestParameters.userKey !== undefined) queryParameters['userKey'] = requestParameters.userKey;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.apiKey) headerParameters["X-Adzerk-ApiKey"] = this.configuration.apiKey("X-Adzerk-ApiKey"); // ApiKeyAuth authentication
                        return [
                            4 /*yield*/ ,
                            this.request({
                                path: "/udb/{networkId}/custom".replace("{".concat("networkId", "}"), encodeURIComponent(String(requestParameters.networkId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: requestParameters.body
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            new $8Xtnd.BlobApiResponse(response)
                        ];
                }
            });
        });
    };
    /**
     * Add Custom Properties to a User
     */ UserdbApi.prototype.addCustomProperties = function(networkId, userKey, body) {
        return $1a5d0513d6de6ad9$var$__awaiter(this, void 0, void 0, function() {
            var response;
            return $1a5d0513d6de6ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.addCustomPropertiesRaw({
                                networkId: networkId,
                                userKey: userKey,
                                body: body
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            response.value()
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Add Interests to a User
     */ UserdbApi.prototype.addInterestsRaw = function(requestParameters) {
        return $1a5d0513d6de6ad9$var$__awaiter(this, void 0, void 0, function() {
            var queryParameters, headerParameters, response;
            return $1a5d0513d6de6ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (requestParameters.networkId === null || requestParameters.networkId === undefined) throw new $8Xtnd.RequiredError('networkId', 'Required parameter requestParameters.networkId was null or undefined when calling addInterests.');
                        if (requestParameters.userKey === null || requestParameters.userKey === undefined) throw new $8Xtnd.RequiredError('userKey', 'Required parameter requestParameters.userKey was null or undefined when calling addInterests.');
                        if (requestParameters.interest === null || requestParameters.interest === undefined) throw new $8Xtnd.RequiredError('interest', 'Required parameter requestParameters.interest was null or undefined when calling addInterests.');
                        queryParameters = {};
                        if (requestParameters.userKey !== undefined) queryParameters['userKey'] = requestParameters.userKey;
                        if (requestParameters.interest !== undefined) queryParameters['interest'] = requestParameters.interest;
                        headerParameters = {};
                        return [
                            4 /*yield*/ ,
                            this.request({
                                path: "/udb/{networkId}/interest/i.gif".replace("{".concat("networkId", "}"), encodeURIComponent(String(requestParameters.networkId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            new $8Xtnd.BlobApiResponse(response)
                        ];
                }
            });
        });
    };
    /**
     * Add Interests to a User
     */ UserdbApi.prototype.addInterests = function(networkId, userKey, interest) {
        return $1a5d0513d6de6ad9$var$__awaiter(this, void 0, void 0, function() {
            var response;
            return $1a5d0513d6de6ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.addInterestsRaw({
                                networkId: networkId,
                                userKey: userKey,
                                interest: interest
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            response.value()
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Add User to a Retargeting Segment
     */ UserdbApi.prototype.addRetargetingSegmentRaw = function(requestParameters) {
        return $1a5d0513d6de6ad9$var$__awaiter(this, void 0, void 0, function() {
            var queryParameters, headerParameters, response;
            return $1a5d0513d6de6ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (requestParameters.networkId === null || requestParameters.networkId === undefined) throw new $8Xtnd.RequiredError('networkId', 'Required parameter requestParameters.networkId was null or undefined when calling addRetargetingSegment.');
                        if (requestParameters.advertiserId === null || requestParameters.advertiserId === undefined) throw new $8Xtnd.RequiredError('advertiserId', 'Required parameter requestParameters.advertiserId was null or undefined when calling addRetargetingSegment.');
                        if (requestParameters.retargetingSegmentId === null || requestParameters.retargetingSegmentId === undefined) throw new $8Xtnd.RequiredError('retargetingSegmentId', 'Required parameter requestParameters.retargetingSegmentId was null or undefined when calling addRetargetingSegment.');
                        if (requestParameters.userKey === null || requestParameters.userKey === undefined) throw new $8Xtnd.RequiredError('userKey', 'Required parameter requestParameters.userKey was null or undefined when calling addRetargetingSegment.');
                        queryParameters = {};
                        if (requestParameters.userKey !== undefined) queryParameters['userKey'] = requestParameters.userKey;
                        headerParameters = {};
                        return [
                            4 /*yield*/ ,
                            this.request({
                                path: "/udb/{networkId}/rt/{advertiserId}/{retargetingSegmentId}/i.gif".replace("{".concat("networkId", "}"), encodeURIComponent(String(requestParameters.networkId))).replace("{".concat("advertiserId", "}"), encodeURIComponent(String(requestParameters.advertiserId))).replace("{".concat("retargetingSegmentId", "}"), encodeURIComponent(String(requestParameters.retargetingSegmentId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            new $8Xtnd.BlobApiResponse(response)
                        ];
                }
            });
        });
    };
    /**
     * Add User to a Retargeting Segment
     */ UserdbApi.prototype.addRetargetingSegment = function(networkId, advertiserId, retargetingSegmentId, userKey) {
        return $1a5d0513d6de6ad9$var$__awaiter(this, void 0, void 0, function() {
            var response;
            return $1a5d0513d6de6ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.addRetargetingSegmentRaw({
                                networkId: networkId,
                                advertiserId: advertiserId,
                                retargetingSegmentId: retargetingSegmentId,
                                userKey: userKey
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            response.value()
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Forget User
     */ UserdbApi.prototype.forgetRaw = function(requestParameters) {
        return $1a5d0513d6de6ad9$var$__awaiter(this, void 0, void 0, function() {
            var queryParameters, headerParameters, response;
            return $1a5d0513d6de6ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (requestParameters.networkId === null || requestParameters.networkId === undefined) throw new $8Xtnd.RequiredError('networkId', 'Required parameter requestParameters.networkId was null or undefined when calling forget.');
                        if (requestParameters.userKey === null || requestParameters.userKey === undefined) throw new $8Xtnd.RequiredError('userKey', 'Required parameter requestParameters.userKey was null or undefined when calling forget.');
                        queryParameters = {};
                        if (requestParameters.userKey !== undefined) queryParameters['userKey'] = requestParameters.userKey;
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) headerParameters["X-Adzerk-ApiKey"] = this.configuration.apiKey("X-Adzerk-ApiKey"); // ApiKeyAuth authentication
                        return [
                            4 /*yield*/ ,
                            this.request({
                                path: "/udb/{networkId}".replace("{".concat("networkId", "}"), encodeURIComponent(String(requestParameters.networkId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            new $8Xtnd.VoidApiResponse(response)
                        ];
                }
            });
        });
    };
    /**
     * Forget User
     */ UserdbApi.prototype.forget = function(networkId, userKey) {
        return $1a5d0513d6de6ad9$var$__awaiter(this, void 0, void 0, function() {
            return $1a5d0513d6de6ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.forgetRaw({
                                networkId: networkId,
                                userKey: userKey
                            })
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * GDPR Consent
     */ UserdbApi.prototype.gdprConsentRaw = function(requestParameters) {
        return $1a5d0513d6de6ad9$var$__awaiter(this, void 0, void 0, function() {
            var queryParameters, headerParameters, response;
            return $1a5d0513d6de6ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (requestParameters.networkId === null || requestParameters.networkId === undefined) throw new $8Xtnd.RequiredError('networkId', 'Required parameter requestParameters.networkId was null or undefined when calling gdprConsent.');
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.apiKey) headerParameters["X-Adzerk-ApiKey"] = this.configuration.apiKey("X-Adzerk-ApiKey"); // ApiKeyAuth authentication
                        return [
                            4 /*yield*/ ,
                            this.request({
                                path: "/udb/{networkId}/consent".replace("{".concat("networkId", "}"), encodeURIComponent(String(requestParameters.networkId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, $2LYTS.ConsentRequestToJSON)(requestParameters.consentRequest)
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            new $8Xtnd.BlobApiResponse(response)
                        ];
                }
            });
        });
    };
    /**
     * GDPR Consent
     */ UserdbApi.prototype.gdprConsent = function(networkId, consentRequest) {
        return $1a5d0513d6de6ad9$var$__awaiter(this, void 0, void 0, function() {
            var response;
            return $1a5d0513d6de6ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.gdprConsentRaw({
                                networkId: networkId,
                                consentRequest: consentRequest
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            response.value()
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * IP Address Override
     */ UserdbApi.prototype.ipOverrideRaw = function(requestParameters) {
        return $1a5d0513d6de6ad9$var$__awaiter(this, void 0, void 0, function() {
            var queryParameters, headerParameters, response;
            return $1a5d0513d6de6ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (requestParameters.networkId === null || requestParameters.networkId === undefined) throw new $8Xtnd.RequiredError('networkId', 'Required parameter requestParameters.networkId was null or undefined when calling ipOverride.');
                        if (requestParameters.userKey === null || requestParameters.userKey === undefined) throw new $8Xtnd.RequiredError('userKey', 'Required parameter requestParameters.userKey was null or undefined when calling ipOverride.');
                        if (requestParameters.ip === null || requestParameters.ip === undefined) throw new $8Xtnd.RequiredError('ip', 'Required parameter requestParameters.ip was null or undefined when calling ipOverride.');
                        queryParameters = {};
                        if (requestParameters.userKey !== undefined) queryParameters['userKey'] = requestParameters.userKey;
                        if (requestParameters.ip !== undefined) queryParameters['ip'] = requestParameters.ip;
                        headerParameters = {};
                        return [
                            4 /*yield*/ ,
                            this.request({
                                path: "/udb/{networkId}/ip/i.gif".replace("{".concat("networkId", "}"), encodeURIComponent(String(requestParameters.networkId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            new $8Xtnd.BlobApiResponse(response)
                        ];
                }
            });
        });
    };
    /**
     * IP Address Override
     */ UserdbApi.prototype.ipOverride = function(networkId, userKey, ip) {
        return $1a5d0513d6de6ad9$var$__awaiter(this, void 0, void 0, function() {
            var response;
            return $1a5d0513d6de6ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.ipOverrideRaw({
                                networkId: networkId,
                                userKey: userKey,
                                ip: ip
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            response.value()
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * User Matching
     */ UserdbApi.prototype.matchUserRaw = function(requestParameters) {
        return $1a5d0513d6de6ad9$var$__awaiter(this, void 0, void 0, function() {
            var queryParameters, headerParameters, response;
            return $1a5d0513d6de6ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (requestParameters.networkId === null || requestParameters.networkId === undefined) throw new $8Xtnd.RequiredError('networkId', 'Required parameter requestParameters.networkId was null or undefined when calling matchUser.');
                        if (requestParameters.userKey === null || requestParameters.userKey === undefined) throw new $8Xtnd.RequiredError('userKey', 'Required parameter requestParameters.userKey was null or undefined when calling matchUser.');
                        if (requestParameters.partnerId === null || requestParameters.partnerId === undefined) throw new $8Xtnd.RequiredError('partnerId', 'Required parameter requestParameters.partnerId was null or undefined when calling matchUser.');
                        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $8Xtnd.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling matchUser.');
                        queryParameters = {};
                        if (requestParameters.userKey !== undefined) queryParameters['userKey'] = requestParameters.userKey;
                        if (requestParameters.partnerId !== undefined) queryParameters['partnerId'] = requestParameters.partnerId;
                        if (requestParameters.userId !== undefined) queryParameters['userId'] = requestParameters.userId;
                        headerParameters = {};
                        return [
                            4 /*yield*/ ,
                            this.request({
                                path: "/udb/{networkId}/sync/i.gif".replace("{".concat("networkId", "}"), encodeURIComponent(String(requestParameters.networkId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            new $8Xtnd.BlobApiResponse(response)
                        ];
                }
            });
        });
    };
    /**
     * User Matching
     */ UserdbApi.prototype.matchUser = function(networkId, userKey, partnerId, userId) {
        return $1a5d0513d6de6ad9$var$__awaiter(this, void 0, void 0, function() {
            var response;
            return $1a5d0513d6de6ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.matchUserRaw({
                                networkId: networkId,
                                userKey: userKey,
                                partnerId: partnerId,
                                userId: userId
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            response.value()
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Opt-Out a User
     */ UserdbApi.prototype.optOutRaw = function(requestParameters) {
        return $1a5d0513d6de6ad9$var$__awaiter(this, void 0, void 0, function() {
            var queryParameters, headerParameters, response;
            return $1a5d0513d6de6ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (requestParameters.networkId === null || requestParameters.networkId === undefined) throw new $8Xtnd.RequiredError('networkId', 'Required parameter requestParameters.networkId was null or undefined when calling optOut.');
                        if (requestParameters.userKey === null || requestParameters.userKey === undefined) throw new $8Xtnd.RequiredError('userKey', 'Required parameter requestParameters.userKey was null or undefined when calling optOut.');
                        queryParameters = {};
                        if (requestParameters.userKey !== undefined) queryParameters['userKey'] = requestParameters.userKey;
                        headerParameters = {};
                        return [
                            4 /*yield*/ ,
                            this.request({
                                path: "/udb/{networkId}/optout/i.gif".replace("{".concat("networkId", "}"), encodeURIComponent(String(requestParameters.networkId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            new $8Xtnd.BlobApiResponse(response)
                        ];
                }
            });
        });
    };
    /**
     * Opt-Out a User
     */ UserdbApi.prototype.optOut = function(networkId, userKey) {
        return $1a5d0513d6de6ad9$var$__awaiter(this, void 0, void 0, function() {
            var response;
            return $1a5d0513d6de6ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.optOutRaw({
                                networkId: networkId,
                                userKey: userKey
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            response.value()
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Read a User\'s UserDB Record
     */ UserdbApi.prototype.readRaw = function(requestParameters) {
        return $1a5d0513d6de6ad9$var$__awaiter(this, void 0, void 0, function() {
            var queryParameters, headerParameters, response;
            return $1a5d0513d6de6ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (requestParameters.networkId === null || requestParameters.networkId === undefined) throw new $8Xtnd.RequiredError('networkId', 'Required parameter requestParameters.networkId was null or undefined when calling read.');
                        if (requestParameters.userKey === null || requestParameters.userKey === undefined) throw new $8Xtnd.RequiredError('userKey', 'Required parameter requestParameters.userKey was null or undefined when calling read.');
                        queryParameters = {};
                        if (requestParameters.userKey !== undefined) queryParameters['userKey'] = requestParameters.userKey;
                        headerParameters = {};
                        return [
                            4 /*yield*/ ,
                            this.request({
                                path: "/udb/{networkId}/read".replace("{".concat("networkId", "}"), encodeURIComponent(String(requestParameters.networkId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            new $8Xtnd.JSONApiResponse(response)
                        ];
                }
            });
        });
    };
    /**
     * Read a User\'s UserDB Record
     */ UserdbApi.prototype.read = function(networkId, userKey) {
        return $1a5d0513d6de6ad9$var$__awaiter(this, void 0, void 0, function() {
            var response;
            return $1a5d0513d6de6ad9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.readRaw({
                                networkId: networkId,
                                userKey: userKey
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            response.value()
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    return UserdbApi;
}($8Xtnd.BaseAPI);
module.exports.UserdbApi = $1a5d0513d6de6ad9$var$UserdbApi;

});


parcelRegister("aRDL6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RateType = module.exports.EventType = void 0;
var $7e8db1e4cf255019$var$EventType;
(function(EventType) {
    EventType[EventType["ViewConversion"] = 1] = "ViewConversion";
    EventType[EventType["ClickConversion"] = 2] = "ClickConversion";
    EventType[EventType["ServerToServerConversion"] = 3] = "ServerToServerConversion";
    EventType[EventType["Upvote"] = 10] = "Upvote";
    EventType[EventType["Downvote"] = 11] = "Downvote";
    EventType[EventType["DownvoteUninteresting"] = 12] = "DownvoteUninteresting";
    EventType[EventType["DownvoteMisleading"] = 13] = "DownvoteMisleading";
    EventType[EventType["DownvoteOffensive"] = 14] = "DownvoteOffensive";
    EventType[EventType["DownvoteRepetitive"] = 15] = "DownvoteRepetitive";
    EventType[EventType["DownvoteOther"] = 16] = "DownvoteOther";
    EventType[EventType["CloseAd"] = 17] = "CloseAd";
    EventType[EventType["Like"] = 20] = "Like";
    EventType[EventType["Share"] = 21] = "Share";
    EventType[EventType["Comment"] = 22] = "Comment";
    EventType[EventType["CommentReply"] = 101] = "CommentReply";
    EventType[EventType["CommentUpvote"] = 102] = "CommentUpvote";
    EventType[EventType["CommentDownvote"] = 103] = "CommentDownvote";
    EventType[EventType["Visible"] = 30] = "Visible";
    EventType[EventType["Hover"] = 31] = "Hover";
    EventType[EventType["ExpandDiv"] = 32] = "ExpandDiv";
    EventType[EventType["ViewableImpression"] = 40] = "ViewableImpression";
    EventType[EventType["ShareOnFacebook"] = 50] = "ShareOnFacebook";
    EventType[EventType["ShareOnTwitter"] = 51] = "ShareOnTwitter";
    EventType[EventType["ShareOnPinterest"] = 52] = "ShareOnPinterest";
    EventType[EventType["ShareOnReddit"] = 53] = "ShareOnReddit";
    EventType[EventType["ShareOnEmail"] = 54] = "ShareOnEmail";
    EventType[EventType["VideoStart"] = 70] = "VideoStart";
    EventType[EventType["VideoFirstQuartile"] = 71] = "VideoFirstQuartile";
    EventType[EventType["VideoMidPoint"] = 72] = "VideoMidPoint";
    EventType[EventType["VideoThirdQuartile"] = 73] = "VideoThirdQuartile";
    EventType[EventType["VideoComplete"] = 74] = "VideoComplete";
    EventType[EventType["VideoMute"] = 75] = "VideoMute";
    EventType[EventType["VideoUnmute"] = 76] = "VideoUnmute";
    EventType[EventType["VideoPause"] = 77] = "VideoPause";
    EventType[EventType["VideoRewind"] = 78] = "VideoRewind";
    EventType[EventType["VideoResume"] = 79] = "VideoResume";
    EventType[EventType["VideoFullScreen"] = 80] = "VideoFullScreen";
    EventType[EventType["VideoExitFullScreen"] = 81] = "VideoExitFullScreen";
    EventType[EventType["VideoExpand"] = 82] = "VideoExpand";
    EventType[EventType["VideoCollapse"] = 83] = "VideoCollapse";
    EventType[EventType["VideoAcceptInvitationLinear"] = 84] = "VideoAcceptInvitationLinear";
    EventType[EventType["VideoCloseLinear"] = 85] = "VideoCloseLinear";
    EventType[EventType["VideoSkip"] = 86] = "VideoSkip";
    EventType[EventType["VideoProgress"] = 87] = "VideoProgress";
    EventType[EventType["VideoZeroSecondsViewed"] = 400] = "VideoZeroSecondsViewed";
    EventType[EventType["VideoOneSecondsViewed"] = 401] = "VideoOneSecondsViewed";
    EventType[EventType["VideoTwoSecondsViewed"] = 402] = "VideoTwoSecondsViewed";
    EventType[EventType["VideoThreeSecondsViewed"] = 403] = "VideoThreeSecondsViewed";
    EventType[EventType["VideoFourSecondsViewed"] = 404] = "VideoFourSecondsViewed";
    EventType[EventType["VideoFiveSecondsViewed"] = 405] = "VideoFiveSecondsViewed";
    EventType[EventType["VideoSixSecondsViewed"] = 406] = "VideoSixSecondsViewed";
    EventType[EventType["VideoSevenSecondsViewed"] = 407] = "VideoSevenSecondsViewed";
    EventType[EventType["VideoEightSecondsViewed"] = 408] = "VideoEightSecondsViewed";
    EventType[EventType["VideoNineSecondsViewed"] = 409] = "VideoNineSecondsViewed";
    EventType[EventType["VideoTenSecondsViewed"] = 410] = "VideoTenSecondsViewed";
    EventType[EventType["VideoFifteenSecondsViewed"] = 415] = "VideoFifteenSecondsViewed";
    EventType[EventType["VideoTwentySecondsViewed"] = 420] = "VideoTwentySecondsViewed";
    EventType[EventType["VideoTwentyFiveSecondsViewed"] = 425] = "VideoTwentyFiveSecondsViewed";
    EventType[EventType["VideoThirtySecondsViewed"] = 430] = "VideoThirtySecondsViewed";
})($7e8db1e4cf255019$var$EventType = module.exports.EventType || (module.exports.EventType = {}));
var $7e8db1e4cf255019$var$RateType;
(function(RateType) {
    RateType[RateType["Flat"] = 1] = "Flat";
    RateType[RateType["CPM"] = 2] = "CPM";
    RateType[RateType["CPC"] = 3] = "CPC";
    RateType[RateType["CPAView"] = 4] = "CPAView";
    RateType[RateType["CPAClick"] = 5] = "CPAClick";
    RateType[RateType["CPAViewAndClick"] = 6] = "CPAViewAndClick";
})($7e8db1e4cf255019$var$RateType = module.exports.RateType || (module.exports.RateType = {}));

});

parcelRegister("4YOW9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

var $bb73f18d00d8f5c5$exports = {};
"use strict";
var $bb73f18d00d8f5c5$var$__createBinding = $bb73f18d00d8f5c5$exports && $bb73f18d00d8f5c5$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bb73f18d00d8f5c5$var$__exportStar = $bb73f18d00d8f5c5$exports && $bb73f18d00d8f5c5$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bb73f18d00d8f5c5$var$__createBinding(exports1, m, p);
};
Object.defineProperty($bb73f18d00d8f5c5$exports, "__esModule", {
    value: true
});
$bb73f18d00d8f5c5$exports.Client = void 0;
var $7fe6b87e11a16ad7$exports = {};
"use strict";
var $7fe6b87e11a16ad7$var$__assign = $7fe6b87e11a16ad7$exports && $7fe6b87e11a16ad7$exports.__assign || function() {
    $7fe6b87e11a16ad7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7fe6b87e11a16ad7$var$__assign.apply(this, arguments);
};
var $7fe6b87e11a16ad7$var$__awaiter = $7fe6b87e11a16ad7$exports && $7fe6b87e11a16ad7$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7fe6b87e11a16ad7$var$__generator = $7fe6b87e11a16ad7$exports && $7fe6b87e11a16ad7$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7fe6b87e11a16ad7$var$__rest = $7fe6b87e11a16ad7$exports && $7fe6b87e11a16ad7$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7fe6b87e11a16ad7$var$__spreadArray = $7fe6b87e11a16ad7$exports && $7fe6b87e11a16ad7$exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $7fe6b87e11a16ad7$var$__importDefault = $7fe6b87e11a16ad7$exports && $7fe6b87e11a16ad7$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($7fe6b87e11a16ad7$exports, "__esModule", {
    value: true
});
$7fe6b87e11a16ad7$exports.Client = void 0;

var $7fe6b87e11a16ad7$var$isomorphic_unfetch_1 = $7fe6b87e11a16ad7$var$__importDefault((parcelRequire("cZg55")));

var $7fe6b87e11a16ad7$var$form_data_1 = $7fe6b87e11a16ad7$var$__importDefault((parcelRequire("3sJij")));

var $7fe6b87e11a16ad7$var$debug_1 = $7fe6b87e11a16ad7$var$__importDefault((parcelRequire("9KWm4")));
var $023cc6e58b949da6$exports = {};
"use strict";
var $023cc6e58b949da6$var$__createBinding = $023cc6e58b949da6$exports && $023cc6e58b949da6$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $023cc6e58b949da6$var$__exportStar = $023cc6e58b949da6$exports && $023cc6e58b949da6$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $023cc6e58b949da6$var$__createBinding(exports1, m, p);
};
Object.defineProperty($023cc6e58b949da6$exports, "__esModule", {
    value: true
});

$023cc6e58b949da6$var$__exportStar((parcelRequire("8Xtnd")), $023cc6e58b949da6$exports);

$023cc6e58b949da6$var$__exportStar((parcelRequire("9g4bz")), $023cc6e58b949da6$exports);

$023cc6e58b949da6$var$__exportStar((parcelRequire("2LYTS")), $023cc6e58b949da6$exports);


var $5b496521b1b3908a$exports = {};
"use strict";
Object.defineProperty($5b496521b1b3908a$exports, "__esModule", {
    value: true
});
$5b496521b1b3908a$exports.removeUndefinedAndBlocklisted = void 0;
var $5b496521b1b3908a$var$removeUndefinedAndBlocklisted = function(obj, blocklist) {
    if (blocklist === void 0) blocklist = [];
    if (Array.isArray(obj)) return obj.map(function(o) {
        return (0, $5b496521b1b3908a$exports.removeUndefinedAndBlocklisted)(o);
    });
    return typeof obj !== 'object' ? obj : Object.keys(obj).reduce(function(acc, key) {
        if (blocklist.includes(key) || obj[key] == undefined) return acc;
        return typeof obj[key] === 'object' ? (acc[key] = (0, $5b496521b1b3908a$exports.removeUndefinedAndBlocklisted)(obj[key], blocklist), acc) : (acc[key] = obj[key], acc);
    }, {});
};
$5b496521b1b3908a$exports.removeUndefinedAndBlocklisted = $5b496521b1b3908a$var$removeUndefinedAndBlocklisted;


$parcel$global.FormData = $parcel$global.FormData || $7fe6b87e11a16ad7$var$form_data_1.default;
var $7fe6b87e11a16ad7$var$log = (0, $7fe6b87e11a16ad7$var$debug_1.default)('adzerk-decision-sdk:client');
var $7fe6b87e11a16ad7$var$isNode = false;
var $7fe6b87e11a16ad7$var$isReactNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
var $7fe6b87e11a16ad7$var$isWebpack = typeof __webpack_require__ === 'function';
var $7fe6b87e11a16ad7$var$deprecatedPlacementFields = [
    [
        'ecpmPartition',
        'ecpmPartitions'
    ]
];
function $7fe6b87e11a16ad7$var$isDecisionMultiWinner(obj) {
    return obj instanceof Array;
}
var $7fe6b87e11a16ad7$var$defaultLogger = function(lvl, msg, meta) {
    if (meta != undefined) $7fe6b87e11a16ad7$var$log("[".concat(lvl, "] ").concat(msg, " [%o]"), meta);
    else $7fe6b87e11a16ad7$var$log("[".concat(lvl, "] ").concat(msg));
};
var $7fe6b87e11a16ad7$var$DecisionClient = function() {
    function DecisionClient(configuration, networkId, logger, siteId, apiKey) {
        this._api = new $023cc6e58b949da6$exports.DecisionApi(configuration);
        this._networkId = networkId;
        this._siteId = siteId;
        this._logger = logger;
        this._apiKey = apiKey;
    }
    DecisionClient.prototype.get = function(request, additionalOpts) {
        return $7fe6b87e11a16ad7$var$__awaiter(this, void 0, void 0, function() {
            var logger, processedRequest, api, response, decisions;
            var _this = this;
            return $7fe6b87e11a16ad7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger = this._logger || $7fe6b87e11a16ad7$var$defaultLogger;
                        logger('info', 'Fetching decisions from Adzerk API');
                        logger('info', 'Processing request: ', request);
                        processedRequest = (0, $5b496521b1b3908a$exports.removeUndefinedAndBlocklisted)(request, [
                            'isMobile'
                        ]);
                        if (processedRequest.enableBotFiltering === undefined) processedRequest.enableBotFiltering = !$7fe6b87e11a16ad7$var$isNode;
                        if (processedRequest.placements === undefined || !processedRequest.placements.length) throw new $023cc6e58b949da6$exports.RequiredError('decisionRequest', 'Each request requires at least one placement');
                        processedRequest.placements.forEach(function(p, idx) {
                            if (p.adTypes === undefined || !p.adTypes.length) throw new $023cc6e58b949da6$exports.RequiredError('placements', 'Each placement requires at least one ad type');
                            for(var _i = 0, deprecatedPlacementFields_1 = $7fe6b87e11a16ad7$var$deprecatedPlacementFields; _i < deprecatedPlacementFields_1.length; _i++){
                                var pair = deprecatedPlacementFields_1[_i];
                                var deprecatedField = pair[0], replacement = pair[1];
                                if ((p[deprecatedField] || undefined) != undefined) logger('warn', "DEPRECATION WARNING: ".concat(deprecatedField, " has been deprecated. Please use ").concat(replacement, " instead."));
                            }
                            p.networkId = p.networkId || _this._networkId;
                            p.siteId = p.siteId || _this._siteId;
                            p.divName = p.divName || "div".concat(idx);
                        });
                        api = this._api;
                        if (!!(additionalOpts === null || additionalOpts === void 0 ? void 0 : additionalOpts.includeExplanation) || !!(additionalOpts === null || additionalOpts === void 0 ? void 0 : additionalOpts.userAgent)) api = api.withPreMiddleware(function(context) {
                            return $7fe6b87e11a16ad7$var$__awaiter(_this, void 0, void 0, function() {
                                var headers, headerObject, headerObject;
                                return $7fe6b87e11a16ad7$var$__generator(this, function(_a) {
                                    if (!context.init.headers) context.init.headers = {};
                                    headers = context.init.headers;
                                    if (!!additionalOpts.includeExplanation) {
                                        logger('warn', "--------------------------------------------------------------\n--------------!!! WARNING - WARNING - WARNING !!!-------------\nYou have opted to include explainer details with this request!\nThis will cause performance degradation and should not be done\nin production environments.\n--------------------------------------------------------------");
                                        if (additionalOpts.desiredAds) {
                                            headerObject = {
                                                apiKey: additionalOpts.apiKey,
                                                desiredAd: additionalOpts.desiredAds
                                            };
                                            headers['x-adzerk-explain'] = JSON.stringify(headerObject);
                                        } else if (additionalOpts.desiredAdMap) {
                                            headerObject = {
                                                apiKey: additionalOpts.apiKey,
                                                desiredAdMap: additionalOpts.desiredAdMap
                                            };
                                            headers['x-adzerk-explain'] = JSON.stringify(headerObject);
                                        } else headers['x-adzerk-explain'] = additionalOpts.apiKey || '';
                                    }
                                    if (!!additionalOpts.userAgent) headers['User-Agent'] = additionalOpts.userAgent || '';
                                    return [
                                        2,
                                        context
                                    ];
                                });
                            });
                        });
                        logger('info', 'Using the processed request: ', processedRequest);
                        return [
                            4,
                            api.getDecisions(processedRequest)
                        ];
                    case 1:
                        response = _a.sent();
                        logger('info', 'Received response: ', response);
                        decisions = response.decisions || {};
                        Object.keys(decisions).forEach(function(k) {
                            if (!$7fe6b87e11a16ad7$var$isDecisionMultiWinner(decisions[k])) decisions[k] = [
                                decisions[k]
                            ];
                        });
                        return [
                            2,
                            response
                        ];
                }
            });
        });
    };
    return DecisionClient;
}();
var $7fe6b87e11a16ad7$var$UserDbClient = function() {
    function UserDbClient(configuration, networkId) {
        this._api = new $023cc6e58b949da6$exports.UserdbApi(configuration);
        this._networkId = networkId;
    }
    UserDbClient.prototype.setCustomProperties = function(userKey, properties, networkId) {
        return $7fe6b87e11a16ad7$var$__awaiter(this, void 0, void 0, function() {
            return $7fe6b87e11a16ad7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this._api.addCustomProperties(networkId || this._networkId, userKey, properties)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    };
    UserDbClient.prototype.addInterest = function(userKey, interest, networkId) {
        return $7fe6b87e11a16ad7$var$__awaiter(this, void 0, void 0, function() {
            return $7fe6b87e11a16ad7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this._api.addInterests(networkId || this._networkId, userKey, interest)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    };
    UserDbClient.prototype.addRetargetingSegment = function(userKey, advertiserId, retargetingSegmentId, networkId) {
        return $7fe6b87e11a16ad7$var$__awaiter(this, void 0, void 0, function() {
            return $7fe6b87e11a16ad7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this._api.addRetargetingSegment(networkId || this._networkId, advertiserId, retargetingSegmentId, userKey)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    };
    UserDbClient.prototype.forget = function(userKey, networkId) {
        return $7fe6b87e11a16ad7$var$__awaiter(this, void 0, void 0, function() {
            return $7fe6b87e11a16ad7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this._api.forget(networkId || this._networkId, userKey)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    };
    UserDbClient.prototype.gdprConsent = function(gdprConsent, networkId) {
        return $7fe6b87e11a16ad7$var$__awaiter(this, void 0, void 0, function() {
            return $7fe6b87e11a16ad7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this._api.gdprConsent(networkId || this._networkId, gdprConsent)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    };
    UserDbClient.prototype.ipOverride = function(userKey, ip, networkId) {
        return $7fe6b87e11a16ad7$var$__awaiter(this, void 0, void 0, function() {
            return $7fe6b87e11a16ad7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this._api.ipOverride(networkId || this._networkId, userKey, ip)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    };
    UserDbClient.prototype.matchUser = function(userKey, partnerId, userId, networkId) {
        return $7fe6b87e11a16ad7$var$__awaiter(this, void 0, void 0, function() {
            return $7fe6b87e11a16ad7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this._api.matchUser(networkId || this._networkId, userKey, partnerId, userId)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    };
    UserDbClient.prototype.optOut = function(userKey, networkId) {
        return $7fe6b87e11a16ad7$var$__awaiter(this, void 0, void 0, function() {
            return $7fe6b87e11a16ad7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this._api.optOut(networkId || this._networkId, userKey)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    };
    UserDbClient.prototype.read = function(userKey, networkId) {
        return $7fe6b87e11a16ad7$var$__awaiter(this, void 0, void 0, function() {
            var record, _a, cookieMonster, _b, dirtyCookies, _c, isNew, _d, adViewTimes, _e, advertiserViewTimes, _f, flightViewTimes, _g, siteViewTimes, _h, campaignViewTimes, _j, pendingConversions, _k, campaignConversions, rest;
            return $7fe6b87e11a16ad7$var$__generator(this, function(_l) {
                switch(_l.label){
                    case 0:
                        return [
                            4,
                            this._api.read(networkId || this._networkId, userKey)
                        ];
                    case 1:
                        record = _l.sent();
                        _a = record.cookieMonster, cookieMonster = _a === void 0 ? undefined : _a, _b = record.dirtyCookies, dirtyCookies = _b === void 0 ? undefined : _b, _c = record.isNew, isNew = _c === void 0 ? undefined : _c, _d = record.adViewTimes, adViewTimes = _d === void 0 ? undefined : _d, _e = record.advertiserViewTimes, advertiserViewTimes = _e === void 0 ? undefined : _e, _f = record.flightViewTimes, flightViewTimes = _f === void 0 ? undefined : _f, _g = record.siteViewTimes, siteViewTimes = _g === void 0 ? undefined : _g, _h = record.campaignViewTimes, campaignViewTimes = _h === void 0 ? undefined : _h, _j = record.pendingConversions, pendingConversions = _j === void 0 ? undefined : _j, _k = record.campaignConversions, campaignConversions = _k === void 0 ? undefined : _k, rest = $7fe6b87e11a16ad7$var$__rest(record, [
                            "cookieMonster",
                            "dirtyCookies",
                            "isNew",
                            "adViewTimes",
                            "advertiserViewTimes",
                            "flightViewTimes",
                            "siteViewTimes",
                            "campaignViewTimes",
                            "pendingConversions",
                            "campaignConversions"
                        ]);
                        return [
                            2,
                            rest
                        ];
                }
            });
        });
    };
    return UserDbClient;
}();
var $7fe6b87e11a16ad7$var$PixelClient = function() {
    function PixelClient(fetch, agent, logger, versionString) {
        this._fetch = fetch;
        this._agent = agent;
        this._logger = logger;
        this._versionString = versionString;
    }
    PixelClient.prototype.buildFireUrl = function(params) {
        var parsed = new URL(params.url);
        if (params.revenueOverride) parsed.searchParams.append('override', params.revenueOverride.toString());
        if (params.additionalRevenue) parsed.searchParams.append('additional', params.additionalRevenue.toString());
        if (params.eventMultiplier) parsed.searchParams.append('eventMultiplier', params.eventMultiplier.toString());
        if (params.grossMerchandiseValue) parsed.searchParams.append('gmv', params.grossMerchandiseValue.toString());
        return parsed.href;
    };
    PixelClient.prototype.fire = function(params, additionalOpts) {
        return $7fe6b87e11a16ad7$var$__awaiter(this, void 0, void 0, function() {
            var logger, headersbase, headers, opts, url, result, location;
            return $7fe6b87e11a16ad7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger = this._logger || $7fe6b87e11a16ad7$var$defaultLogger;
                        headersbase = {
                            'X-Adzerk-Sdk-Version': this._versionString
                        };
                        if (typeof window === 'undefined') headersbase['User-Agent'] = (additionalOpts === null || additionalOpts === void 0 ? void 0 : additionalOpts.userAgent) || 'OpenAPI-Generator/1.0/js';
                        headers = (additionalOpts === null || additionalOpts === void 0 ? void 0 : additionalOpts.apiKey) ? $7fe6b87e11a16ad7$var$__assign($7fe6b87e11a16ad7$var$__assign({}, headersbase), {
                            'X-Kevel-ApiKey': additionalOpts.apiKey
                        }) : headersbase;
                        opts = {
                            method: 'GET',
                            headers: headers,
                            redirect: 'manual'
                        };
                        url = this.buildFireUrl(params);
                        logger('info', "Firing Pixel at base url of: ".concat(url));
                        if (!!this._agent) opts.agent = this._agent;
                        return [
                            4,
                            this._fetch(url, opts)
                        ];
                    case 1:
                        result = _a.sent();
                        if (result.headers.has('location')) location = result.headers.get('location');
                        logger('info', "Received response from pixel url: ".concat(result.status, " with location: ").concat(location));
                        return [
                            2,
                            {
                                status: result.status,
                                location: result.headers.has('location') ? result.headers.get('location') : undefined
                            }
                        ];
                }
            });
        });
    };
    return PixelClient;
}();
var $7fe6b87e11a16ad7$var$Client = function() {
    function Client(opts) {
        var _this = this;
        var fetch = (opts.fetch || $7fe6b87e11a16ad7$var$isomorphic_unfetch_1.default).bind($parcel$global);
        var logger = opts.logger || $7fe6b87e11a16ad7$var$defaultLogger;
        var protocol = opts.protocol || 'https';
        var host = opts.host || "e-".concat(opts.networkId, ".adzerk.net");
        var basePath = "".concat(protocol, "://").concat(host);
        var versionString = 'adzerk-decision-sdk-js:1.0.0-beta.28';
        var adzerkApiKey = opts.apiKey;
        if (!!opts.additionalVersionInfo) versionString = "".concat(opts.additionalVersionInfo, ";").concat(versionString);
        this._path = opts.path;
        if ($7fe6b87e11a16ad7$var$isNode && !$7fe6b87e11a16ad7$var$isReactNative && !$7fe6b87e11a16ad7$var$isWebpack) {
            var Agent = require(protocol).Agent;
            this._agent = opts.agent || new Agent({
                keepAlive: true,
                timeout: 10000
            });
        }
        var middleware = {
            pre: function(context) {
                return $7fe6b87e11a16ad7$var$__awaiter(_this, void 0, void 0, function() {
                    var headers;
                    return $7fe6b87e11a16ad7$var$__generator(this, function(_a) {
                        logger('info', "Request Url: ".concat(context.url));
                        logger('info', "Request Headers: ".concat(context.init.headers));
                        logger('info', "Request Body: ".concat(context.init.body));
                        if (this._agent != undefined) context.init.agent = this._agent;
                        if (this._path != undefined) context.url = "".concat(basePath).concat(this._path);
                        if (!context.init.headers) context.init.headers = {};
                        headers = context.init.headers;
                        headers['X-Adzerk-Sdk-Version'] = versionString;
                        if (adzerkApiKey) headers['X-Adzerk-ApiKey'] = adzerkApiKey;
                        return [
                            2,
                            context
                        ];
                    });
                });
            },
            post: function(context) {
                return $7fe6b87e11a16ad7$var$__awaiter(_this, void 0, void 0, function() {
                    return $7fe6b87e11a16ad7$var$__generator(this, function(_a) {
                        logger('info', "Response Code: ".concat(context.response.status));
                        logger('info', "Response Status Text: ".concat(context.response.statusText));
                        return [
                            2,
                            context.response
                        ];
                    });
                });
            }
        };
        var configuration = new $023cc6e58b949da6$exports.Configuration({
            basePath: basePath,
            fetchApi: fetch,
            apiKey: opts.apiKey,
            middleware: $7fe6b87e11a16ad7$var$__spreadArray($7fe6b87e11a16ad7$var$__spreadArray([], opts.middlewares || [], true), [
                middleware
            ], false)
        });
        this._decisionClient = new $7fe6b87e11a16ad7$var$DecisionClient(configuration, opts.networkId, logger, opts.siteId, adzerkApiKey);
        this._userDbClient = new $7fe6b87e11a16ad7$var$UserDbClient(configuration, opts.networkId);
        this._pixelClient = new $7fe6b87e11a16ad7$var$PixelClient(fetch, this._agent, logger, versionString);
    }
    Object.defineProperty(Client.prototype, "decisions", {
        get: function() {
            return this._decisionClient;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Client.prototype, "userDb", {
        get: function() {
            return this._userDbClient;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Client.prototype, "pixels", {
        get: function() {
            return this._pixelClient;
        },
        enumerable: false,
        configurable: true
    });
    return Client;
}();
$7fe6b87e11a16ad7$exports.Client = $7fe6b87e11a16ad7$var$Client;


Object.defineProperty($bb73f18d00d8f5c5$exports, "Client", {
    enumerable: true,
    get: function() {
        return $7fe6b87e11a16ad7$exports.Client;
    }
});

$bb73f18d00d8f5c5$var$__exportStar((parcelRequire("aRDL6")), $bb73f18d00d8f5c5$exports);

$bb73f18d00d8f5c5$var$__exportStar((parcelRequire("4YOW9")), $bb73f18d00d8f5c5$exports);
globalThis.AdzerkDecisionSdk = $bb73f18d00d8f5c5$exports;

})();
//# sourceMappingURL=adzerk-decision-sdk.js.map
